<template>
  <div class="row">
    <div class="col-md-12">
      <h4>Create From</h4>
    </div>

    <div class="col-md-12">
      <div id="surveyCreatorContainerForm"></div>
    </div>
   
    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('form_information') }}</h4>
      <ValidationObserver ref="formBuilderForm">
        <form>
          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.title" :placeholder="$t('name')" :label="$t('form_name')"></fg-input>
          </ValidationProvider>

          <fg-input :label="$t('select_ngo')">
            <el-select size="large" class="select-primary" filterable clearable v-model="form.ngo_ID"
              :placeholder="$t('select_ngo')">
                <el-option
                  v-for="item in ngos"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
          </fg-input>

          <fg-input :label="$t('select_country')">
            <el-select size="large" class="select-primary" filterable multiple clearable v-model="form.location_ID"
              :placeholder="$t('select_country')">
                <el-option
                  v-for="item in locations"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
          </fg-input>

        </form>
      </ValidationObserver>

      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button
            type="info"
            link
            @click="createForm"
          >{{ $t('create_form') }}</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import * as SurveyCreator from "survey-creator";
import "survey-creator/survey-creator.css";
import Modal from "src/components/UIComponents/Modal.vue";

import Resource from "@/util/Api/resource.js";
const CategoryResource = new Resource("category");
const SurveyForm = new Resource("surveys");

export default {
  name: "form-builder",
  components: {
     Modal
  },
  data() {
    return {
      modals: {
         classic: false
      },
      form: {
         title: '',
         ngo_ID:'',
         location_ID: '',
         formTemplate:null,
         otherFields:'',
      },
      formContent: "",
      categories: [],
      ngos: [],
      locations: [],
    };
  },
  created() {
    this.getCategories();
  },
  mounted() {
    SurveyCreator.StylesManager.applyTheme("bootstrap");

    let options = {};

    let surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainerForm",
      options
    );

    surveyCreator.showToolbox = "right";
    surveyCreator.showPropertyGrid = "right";
    surveyCreator.rightContainerActiveItem("toolbox");

    surveyCreator.haveCommercialLicense = true;
    const vm = this;

    surveyCreator.saveSurveyFunc = function() {
      const formContent = JSON.parse(this.text);
      vm.openUpdateModal(formContent);
    };

  },

  methods: {
    // getting all category
    async getCategories() {
      await CategoryResource.list({})
        .then(response => {
          this.categories = response.data;
          this.categories.forEach((value) => {
             if(value.id === 1) {
                value.children.forEach((element) => {
                   this.ngos.push(element);
                });
             } else if(value.id === 2){
                value.children.forEach((element) => {
                   this.locations.push(element);
                });
             }
          })
        })
        .catch(error => {
          console.log("error occured");
        });
    },

    // alert message
    showAlertMessage(message, type){
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    // reset form
    resetForm() {
      this.formName = "";
      this.$refs.formBuilderForm.reset();
    },

    // close modal function
    handleCloseModal(){
      this.modals.classic = false;
      this.resetForm()
    },

    // Open modal
    openUpdateModal(formContent){
      this.modals.classic = true;
      this.formContent = formContent;
    },

    // Create Form
    async createForm() {

      let formData = new FormData();
      formData.append("title", this.form.title);
      formData.append("ngo_id", this.form.ngo_ID);
      formData.append("location_ID", this.form.location_ID);
      formData.append("formTemplate", JSON.stringify(this.formContent));

      await SurveyForm.store(formData)
      .then(response => {
        this.showAlertMessage( this.$t("form_template_created_successfully"), "success")
        this.$router.push({name: "FormBuilder"});
      }).catch(error => {
        if (error.response.data.error) {
          this.$refs.formBuilderForm.setErrors(error.response.data.error.message);
        }
      });
    }

  }
};
</script>
